import React, { useEffect, useState } from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CircularProgress, TextField } from '@material-ui/core';
import Http from '../Http';

export default function AutocompleteComponent(props) {
   const [open, setOpen] = useState(false);
   const [inputValue, setInputValue] = useState('');
   const [options, setOptions] = useState(props.options || []);
   const [valueA, setValueA] = useState(props.value || '');
   const [loading, setLoading] = useState(false);

   useEffect(() => {
      if (props.options && Array.isArray(props.options)) {
         setOptions(props.options)
      }
      if (props.value !== valueA) {
         setValueA(props.value);
      }
   }, [props.options, props.value]);

   useEffect(() => {
      if (props.reset) {
         setInputValue('');
         props.onResetChange(false);
      }
   }, [props.reset])
   

   const apiCall = (text = '', reason) => {
      if (props.cp && text.length > 5) { return }
      if (reason !== 'reset' || (reason === 'reset' && ![null, ''].includes(text))) {
         setInputValue(text || '');
      }
      if (props.apiUrl && ((!props.cp && text.length > 1 && reason === 'input') || (props.cp && text.length === 5 && reason === 'input'))) {
         if (loading) { return }
         setLoading(true);
         const res = Http.post(props.apiUrl, { search: text });
         res.then(d => {
            if (d.data) {
               props.onOptionsChange(d.data);
               if (props.cp && d.data[0]) {
                  props.onChange({ target: { value: d.data[0].Value } });
               }
            }
            setLoading(false);
         }).catch(() => {
            setLoading(false);
         });
      }
   }

   const onChange = (ev, option, reason) => {
      if (loading) { return }
      if (['select-option', 'remove-option', 'clear'].includes(reason)) {
         props.onChange({ target: { value: option ? option.Value : '' } });
      }
   }

   const value = options.find(o => o.Value == valueA) || { Value: '', Label: '' };
   return (
      <Autocomplete
         open={open}
         onOpen={() => { setOpen(true); }}
         onClose={() => { setOpen(false); }}

         value={value}
         onChange={onChange}
         getOptionLabel={(option) => option ? (option.Label || '' ) : ''}

         inputValue={(inputValue == '' && !!valueA) ? (value.Label) : inputValue}
         onInputChange={(e, value, reason) => { apiCall(value, reason) }}

         style={props.style}
         disabled={props.disabled}
         options={options}
         loading={loading}
         renderInput={(params) => (
            <TextField
               {...params}
               label={props.label}
               variant="outlined"
               fullWidth
               InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                     <React.Fragment>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                     </React.Fragment>
                  ),
               }}
            />
         )}
      />
   )
}
